const initialState = {
  fieldsThatDefaulted: {},
};

export function formTrackingReducer(state = initialState, action) {
  switch (action.type) {
    case 'REGISTER_DEFAULTED_FIELD':
      return {
        ...state,
        fieldsThatDefaulted: {
          ...state.fieldsThatDefaulted,
          [action.payload.fieldName]: action.payload.defaultValue,
        },
      };
    case 'CLEAR_DEFAULTED_FIELD':
      /* eslint-disable no-case-declarations */
      const { [action.payload.fieldName]: _, ...rest } =
        state.fieldsThatDefaulted;
      return {
        ...state,
        fieldsThatDefaulted: rest,
      };
    case 'CLEAR_DEFAULTED_FIELDS':
      return {
        ...state,
        fieldsThatDefaulted: {},
      };
    default:
      return state;
  }
}
